import { PropsWithChildren } from 'react'

import type { IWisDetailsModalHeadingProps } from './types'

export const WisDetailsModalHeading = ({
  children,
  isSubHeader,
  isInAccordion
}: PropsWithChildren<IWisDetailsModalHeadingProps>) => {
  if (isSubHeader) {
    return (
      <div className='mb-2 mt-4 font-medium text-sm text-gray-500'>
        {children}
      </div>
    )
  }

  return (
    <div
      className={`${isInAccordion ? 'px-3' : 'px-6'} my-4 font-medium text-sm text-gray-500`}
    >
      <span className='uppercase'>{children}</span>
    </div>
  )
}

export default WisDetailsModalHeading
